import { trackEvent } from "./track";

const getSlideData = (slide) => {
    const img = slide.querySelector("img");
    const imagePath = img?.getAttribute("src") || "";

    let slideTitle = slide.dataset.slideTitle || slide.getAttribute("slideTitle");
    if (!slideTitle || !slideTitle.trim()) {
        const heading = slide.querySelector("h1, h2, h3, h4, h5, h6");
        slideTitle = heading?.innerText?.trim() || "";
    }

    const link = slide.querySelector("a");
    const linkHref = link?.getAttribute("href") || "";

    const slideText = slide.innerText?.replace(/[\r\n]+/g, " ").trim() || "";

    return { imagePath, slideTitle, linkHref, slideText };
};

const trackActiveSlide = (carousel) => {
    const activeSlide = carousel.querySelector(".carousel__slide.tns-slide-active");

    if (!activeSlide) return;

    const { imagePath, slideTitle, linkHref, slideText } = getSlideData(activeSlide);

    trackEvent({
        event: "click_item_carousel",
        ...(imagePath && { banner_name: imagePath }),
        ...(slideTitle && { item_name: slideTitle }),
        ...(linkHref && { element_url: linkHref }),
        ...(slideText && { element_text: slideText })
    });
};

const trackSlide = (slide) => {
    if (!slide) return;

    const { imagePath, slideTitle, linkHref, slideText } = getSlideData(slide);

    trackEvent({
        event: "click_item_carousel",
        ...(imagePath && { banner_name: imagePath }),
        ...(slideTitle && { item_name: slideTitle }),
        ...(linkHref && { element_url: linkHref }),
        ...(slideText && { element_text: slideText })
    });
};

const trackCarouselSlide = (carousel) => {
    if (!carousel) return;

    if (carousel.dataset.trackingInitialized) return;
    carousel.dataset.trackingInitialized = "true";

    // Track slide info on click
    const slides = carousel.querySelectorAll(".carousel__slide");
    slides?.forEach((slide) => {
        slide.addEventListener("click", () => {
            trackSlide(slide);
        });
    });

    // Track active slide on click of prev/next buttons
    const carouselControls = carousel.querySelector(".carousel__controls");

    if (carouselControls) {
        const prevButton = carouselControls.querySelector("button.carousel__controls--prev");
        const nextButton = carouselControls.querySelector("button.carousel__controls--next");

        [prevButton, nextButton].forEach((btn) => {
            btn?.addEventListener("click", () => {
                setTimeout(() => trackActiveSlide(carousel), 0);
            });
        });
    }

    // Track active slide on click of navigation buttons
    const carouselNavs = carousel.querySelector(".tns-nav");

    if (carouselNavs) {
        const navButtons = carouselNavs.querySelectorAll("button");

        navButtons.forEach((navBtn) => {
            navBtn?.addEventListener("click", () => {
                setTimeout(() => trackActiveSlide(carousel), 0);
            });
        });
    }

    // Track active slide on click of pagination buttons
    const carouselPagination = carousel.querySelector(".carousel__simplifiedPagination");

    if (carouselPagination) {
        const observer = new MutationObserver(() => {
            const paginationButtons = carouselPagination.querySelectorAll("button:not([data-tracked])");

            if (paginationButtons.length > 0) {
                paginationButtons.forEach((pagBtn) => {
                    pagBtn.setAttribute("data-tracked", "true");
                    pagBtn.addEventListener("click", () => {
                        setTimeout(() => trackActiveSlide(carousel), 0);
                    });
                });

                observer.disconnect(); // stop observing once buttons are found and hooked
            }
        });

        observer.observe(carouselPagination, {
            childList: true,
            subtree: true,
        });
    }
};

export { getSlideData, trackActiveSlide, trackSlide, trackCarouselSlide };
